import React, { useRef } from 'react';
import { Column, GridOption, SlickgridReactInstance } from 'slickgrid-react';
import SlickGridComponent from '../../index'; // 确保路径正确
import './index.module.less'; // 确保路径正确

// 模拟数据
const dataSource = Array.from(Array(10).keys()).map(i => ({
  id: i,
  col1: `Value ${i}-1`,
  col2: `Value ${i}-2`,
  col3: `Value ${i}-3`,
  col4: `Value ${i}-4`,
  col5: `Value ${i}-5`,
  col6: `Value ${i}-6`,
  col7: `Value ${i}-7`,
  col8: `Value ${i}-8`,
}));

const ThreeLevelHeaderExample = () => {
  const gridRef = useRef<SlickgridReactInstance | null>(null);

  // SlickGrid 配置项
  const gridOptions: GridOption = {
    enableCellNavigation: true,
    // 关键配置：启用预表头面板，这将用于显示多层表头
    createPreHeaderPanel: true,
    showPreHeaderPanel: true,
    // 根据你的需求调整预表头和表头行的高度，以容纳多层表头
    // 假设每层表头需要25px，三层就是75px
    preHeaderPanelHeight: 50, // 为两层预留空间 (顶部大组 + 中间小组)
    headerRowHeight: 25, // 为最底层的列名预留空间
    enableGrouping: true, // 启用分组功能（虽然不直接用于表头分组，但通常与此相关）
  };

  // 定义列，通过 columnGroup 的命名和列的顺序来实现三层表头
  const columns: Column[] = [
    // ------------- 第一层: 销售数据 -------------
    // 第二层: 产品A
    {
      id: 'col1',
      name: '数量', // 第三层
      field: 'col1',
      minWidth: 100,
      columnGroup: '销售数据::产品A', // 格式化为 "第一层::第二层"
    },
    {
      id: 'col2',
      name: '金额', // 第三层
      field: 'col2',
      minWidth: 100,
      columnGroup: '销售数据::产品A', // 格式化为 "第一层::第二层"
    },
    // 第二层: 产品B
    {
      id: 'col3',
      name: '数量', // 第三层
      field: 'col3',
      minWidth: 100,
      columnGroup: '销售数据::产品B', // 格式化为 "第一层::第二层"
    },
    {
      id: 'col4',
      name: '金额', // 第三层
      field: 'col4',
      minWidth: 100,
      columnGroup: '销售数据::产品B', // 格式化为 "第一层::第二层"
    },
    // ------------- 第一层: 库存数据 -------------
    // 第二层: 仓库A
    {
      id: 'col5',
      name: '库存', // 第三层
      field: 'col5',
      minWidth: 100,
      columnGroup: '库存数据::仓库A', // 格式化为 "第一层::第二层"
    },
    {
      id: 'col6',
      name: '预警', // 第三层
      field: 'col6',
      minWidth: 100,
      columnGroup: '库存数据::仓库A', // 格式化为 "第一层::第二层"
    },
    // 第二层: 仓库B
    {
      id: 'col7',
      name: '库存', // 第三层
      field: 'col7',
      minWidth: 100,
      columnGroup: '库存数据::仓库B', // 格式化为 "第一层::第二层"
    },
    {
      id: 'col8',
      name: '预警', // 第三层
      field: 'col8',
      minWidth: 100,
      columnGroup: '库存数据::仓库B', // 格式化为 "第一层::第二层"
    },
  ];

  const gridReady = (reactGrid: SlickgridReactInstance) => {
    gridRef.current = reactGrid;
  };

  return (
    <div style={{ height: '400px', position: 'relative' }}>
      <h3>三层表头示例 (通过 columnGroup 命名约定和列顺序)</h3>
      <p>
        **第一层**：销售数据 | 库存数据<br/>
        **第二层**：产品A, 产品B | 仓库A, 仓库B<br/>
        **第三层**：数量, 金额 | 库存, 预警
      </p>
      <SlickGridComponent
        loading={false}
        gridId='multi_header_grid'
        gridOptions={gridOptions}
        columnDefinitions={columns}
        dataset={dataSource}
        onReactGridCreated={(e) => gridReady(e.detail)}
      />
    </div>
  );
};

export default ThreeLevelHeaderExample;